import type { FC } from 'react';
import type { ApexOptions } from 'apexcharts';
import { useTheme } from '@mui/material/styles';
import { Chart } from 'src/components/chart';

type ChartSeries = number[];

const useChartOptions = (): ApexOptions => {
  const theme = useTheme();
  return {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    colors: ['#95DF8F'],
    fill: {
      opacity: 1,
      type: 'solid',
    },
    labels: [''],
    stroke: {
      lineCap: 'round',
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 360,

        dataLabels: {
          show: false,
          name: {
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
          },
          value: {
            color: theme.palette.text.secondary,
          },
        },
        hollow: {
          size: '75%',
          margin: 15,
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
          // @ts-ignore
          image: ['/assets/iconly/Property 1=Evaluation.svg'],
          imageWidth: 30,
          imageHeight: 30,
          imageClipped: false,
        },

        track: {
          background: ['#95DF8F38'],
          strokeWidth: '100%',
          margin: 0,
        },
      },
    },

    states: {
      active: {
        filter: {
          type: 'none',
        },
      },
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    theme: {
      mode: theme.palette.mode,
    },
  };
};

export const RadialChartDocumentation = ({ dataRes }: any) => {
  const chartOptions = useChartOptions();

  // const percentageDisplay =0
    // dataRes?.actualDocumentationTask && dataRes?.totalDocumentationTask
    //   ? (dataRes?.actualDocumentationTask / dataRes?.totalDocumentationTask) * 100
    //   : 0;

  const chartSeries: ChartSeries = [!!dataRes ? dataRes : 0];
  return (
    <Chart
      height={110}
      options={chartOptions}
      series={chartSeries}
      type="radialBar"
    />
  );
};
